import { flatten, uniq } from 'lodash';

import { ItineraryLegModel } from '@/lib/models/itinerary/types';
import { LocationDictionaryModel, LocationModel } from '@/lib/models/location/types';

export const getItineraryLocations = (
  legs: ItineraryLegModel[],
  locations: LocationDictionaryModel,
): LocationModel[] => {
  const locationIds = legs.map((leg) => [leg.fromId, ...leg.stopIds, leg.toId]);
  const uniqIds = uniq(flatten(locationIds));
  return uniqIds.map((id) => locations[id]);
};
